//@*/*
//    BCS  Appv0.91
//    * Copyright (c) 2024, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To 13Soulsrun.org, in perpetuity
//    */
//

/* eslint-disable */
//line_cnt_by_weeks
const home = () => import("../components/home.vue");
const register = () => import("../components/register.vue");
const participant = () => import("../components/participant.vue");
const volunteer = () => import("../components/volunteer.vue");
const checkout = () => import("../components/checkout.vue");
const checkout2 = () => import("../components/checkout2.vue");
const checkout3 = () => import("../components/checkout3.vue");
const completed = () => import("../components/completed.vue");
const admin = () => import("../components/admin.vue");

const pagenoutfound = () => import("../components/pagenoutfound.vue");

export const routes = [
  { name: "home", path: "/", component: home, display: "Home", icon: "Home" },
  {
    name: "completed",
    path: "/completed",
    component: completed,
    display: "completed",
  },
  {
    name: "admin",
    path: "/admin",
    component: admin,
    display: "admin",
  },
  {
    name: "register",
    path: "/register",
    component: register,
    display: "register",
  },
    {
    name: "participant",
    path: "/participant",
    component: participant,
    display: "participant",
  },
  {
    name: "volunteer",
    path: "/volunteer",
    component: volunteer,
    display: "volunteer",
  },
  {
    name: "checkout",
    path: "/checkout",
    component: checkout,
    display: "checkout",
  },
  {
    name: "checkout2",
    path: "/checkout2",
    component: checkout2,
    display: "checkout2",
  },
  {
    name: "checkout3",
    path: "/checkout3",
    component: checkout3,
    display: "checkout3",
  },
  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
